enum SkusEnum {
  'filters' = 'filters',
  'close_filters' = 'close_filters',
  'remove_filterName_filter' = 'remove_filterName_filter',
  'type' = 'type',
  'status' = 'status',
  'has_bid' = 'has_bid',
  'has_ask' = 'has_ask',
  'price' = 'price',
  'apply' = 'apply',
  'country' = 'country',
  'region' = 'region',
  'brand' = 'brand',
  'distilled_year' = 'distilled_year',
  'bottle_size' = 'bottle_size',
  'clear_all_filters' = 'clear_all_filters',
  'numberVariable_results' = 'numberVariable_results',
  'switch_to_grid_view' = 'switch_to_grid_view',
  'switch_to_list_view' = 'switch_to_list_view',
  'has_bids' = 'has_bids',
  'has_asks' = 'has_asks',
  'primary_filters' = 'primary_filters',
  'secondary_filters' = 'secondary_filters',
  'active_filters' = 'active_filters',
}

export { SkusEnum };
